import {
  DSButton,
  DSLinkButton,
} from "@components/design-system/molecules";
import {
  faPhone,
  faMobileAlt,
} from "@fortawesome/free-solid-svg-icons";
import { faMessages } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SCRIBEPHONE_BENEFITS = [
  {
    icon: faMobileAlt,
    text: "Call from the web or mobile app",
    bgColor: "bg-purple-100 dark:bg-purple-900/30",
    iconColor: "text-indigo-600 dark:text-indigo-400",
  },
  {
    icon: faMessages,
    text: "Record both sides of your calls",
    bgColor: "bg-red-100 dark:bg-red-900/30",
    iconColor: "text-red-600 dark:text-red-400",
  },
  {
    icon: faPhone,
    text: "Use your clinic's number (optional)",
    bgColor: "bg-blue-100 dark:bg-blue-900/30",
    iconColor: "text-green-600 dark:text-green-400",
  },
];

function ScribephoneBenefit({ icon, text, bgColor, iconColor }) {
  return (
    <div className="flex items-center space-x-3">
      <div
        className={`shrink-0 w-8 h-8 ${bgColor} rounded-full flex items-center justify-center`}
      >
        <FontAwesomeIcon
          icon={icon}
          className={`${iconColor} text-sm`}
        />
      </div>
      <span className="text-sm text-primary">{text}</span>
    </div>
  );
}

export default function ScribephoneUnactivatedState({ onDismiss }) {
  return (
    <div className="flex flex-col items-center justify-center py-2 px-6 max-w-2xl mx-auto">
      <h3 className="text-xl font-semibold text-primary mb-3 text-center">
        Try Scribephone to generate notes from your calls
      </h3>

      <div className="space-y-3 mb-8 w-full">
        {SCRIBEPHONE_BENEFITS.map((benefit, index) => (
          <ScribephoneBenefit
            key={index}
            icon={benefit.icon}
            text={benefit.text}
            bgColor={benefit.bgColor}
            iconColor={benefit.iconColor}
          />
        ))}
      </div>

      <div className="flex flex-col items-center justify-center gap-md">
        <DSButton onClick={onDismiss} size="lg">
          Get Started
        </DSButton>

        <DSLinkButton
          href="https://www.scribenote.com/blog/introducing-scribephone-making-client-communication-a-walk-in-the-bark"
          target="_blank"
          rel="noreferrer"
        >
          Learn more about Scribephone
        </DSLinkButton>
      </div>
    </div>
  );
}
